export default __webpack_public_path__ + "static/media/screen_livechat_14.e4a84e52.png";